module.exports = __webpack_public_path__ + "static/media/maid.31e6547d.png";